import React from 'react';
import cn from 'classname';
import './index.less';

import moment from 'moment';

import get from 'lodash/get';
import includes from 'lodash/includes';

import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form';

import * as options from './options';

import SelectField from '../../../../../../../../shared/form-elements/select';
import withIntl from '../../../../../../../../shared/intl-hoc';

const background = {
	en: require('../../../../../../../../../apps/rocket/assets/img/dashboard/bday-city-popup-bg-en.png'),
	ru: require('../../../../../../../../../apps/rocket/assets/img/dashboard/bday-city-popup-bg-ru.png')
};

function BirthdayAndCityPopup({ intl, dispatch, popup, click, changeAbilityToClickOutside, ...props }) {
	async function submit({ birthday, city }) {
		const errors = [];

		if (!city) {
			errors.push('city');
		}

		if (!birthday || !birthday.day) {
			errors.push('birthday.day');
		}

		if (!birthday || !birthday.month) {
			errors.push('birthday.month');
		}

		if (!birthday || !birthday.year) {
			errors.push('birthday.year');
		}

		if (errors.length) {
			throw new SubmissionError({ _error: errors });
		}

		return click(undefined, {
			contentId: popup.content.id,
			data: {
				birthday: `${birthday.year.value}-${birthday.month.value}-${birthday.day.value}`,
				city_id: city.value
			}
		});
	}

	function checkIsError(field) {
		return !get(props.values, field) && includes(props.error, field);
	}

	return (
		<div
			className='birthday-city-popup'
			style={{
				background: `url('${intl.language === 'ru' ? background.ru : background.en}')`
			}}
		>
			<form
				className='birthday-city-popup--form'
				onSubmit={props.handleSubmit(submit)}
			>
				<div className='birthday-city-popup--fields'>
					<div className='birthday-city-popup--field--city-wrapper'>
						<div className='birthday-city-popup--field--label'>
							{intl('Город')}:
						</div>
						<Field
							className={cn('birthday-city-popup--field--city', checkIsError('city') && 'error')}
							name='city'
							component={SelectField}
							onFocus={() => changeAbilityToClickOutside(false)}
							searchable
							loadOptions={(...rest) => dispatch(options.lookupCities(...rest))}
						/>
					</div>
					<div className='birthday-city-popup--field--city-wrapper'>
						<div className='birthday-city-popup--field--label'>
							{intl('Дата рождения')}:
						</div>
						<Field
							className={cn('birthday-city-popup--field--day', checkIsError('birthday.day') && 'error')}
							name='birthday.day'
							component={SelectField}
							onFocus={() => changeAbilityToClickOutside(false)}
							options={options.days}
						/>
						<Field
							className={cn('birthday-city-popup--field--month', checkIsError('birthday.month') && 'error')}
							name='birthday.month'
							component={SelectField}
							onFocus={() => changeAbilityToClickOutside(false)}
							options={options.months}
						/>
						<Field
							className={cn('birthday-city-popup--field--year', checkIsError('birthday.year') && 'error')}
							name='birthday.year'
							component={SelectField}
							onFocus={() => changeAbilityToClickOutside(false)}
							options={options.years}
						/>
					</div>
				</div>
				<button className='birthday-city-popup--button'>
					<div>{intl('Отправить')}</div>
				</button>
			</form>
		</div>
	);
}

function mapStateToProps(state) {
	const { city, birthday } = state.app.userData.general;

	return {
		initialValues: {
			city: city && { value: city.id, label: city.text },
			birthday: birthday && {
				day: options.numberToStringOption(moment(birthday).date()),
				month: options.numberToStringOption(moment(birthday).month() + 1),
				year: moment(birthday).year() <= 1900
					? null
					: options.numberToStringOption(moment(birthday).year())
			}
		}
	};
}

export default connect(mapStateToProps)(
	reduxForm({ form: 'birthdayAndCityPopupForm' })(
		connect((state, { form }) => ({ values: getFormValues(form)(state) }))(
			withIntl(BirthdayAndCityPopup)
		)
	)
);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/popup/render-popup/render-custom-popup/custom-popups/birthday-and-city-popup/index.js